import { View, ViewModel, ObservableArray, ViewGenerator } from "binder";
import { LineItemViewModel } from "./lineItem-viewModel"

export class LineItemView extends View<LineItemViewModel>{
    GetViewUniqueId(): string {
        return "V-AF6FDFC8-7AFE-46EA-9ACE-34D33A7A00F8"
    }
    loadHtml(): string {
        let element = require('./lineItem.html').default;
        let style = require('./lineItem.less');
        return element;
    }
    constructor() {
       super();
    }
    public set element(v: ViewModel) { this._element = v; } public get element(): ViewModel { return this._element;} private _element: ViewModel;
    public set template(v: Node) { this._template = v; } public get template(): Node { return this._template;} private _template: Node;
    public set internalItems(v: ObservableArray<LineItemViewModel>) { this._internalItems = v; } public get internalItems(): ObservableArray<LineItemViewModel> { return this._internalItems;} private _internalItems: ObservableArray<LineItemViewModel>;
    public set hasChild(v: boolean) { this._hasChild = v; } public get hasChild(): boolean { return this._hasChild;} private _hasChild: boolean;
    public set isOpen(v: boolean) { this._isOpen = v; } public get isOpen(): boolean { return this._isOpen;} private _isOpen: boolean;
    public set isFiltered(v: boolean) { this._isFiltered = v; } public get isFiltered(): boolean { return this._isFiltered;} private _isFiltered: boolean;
    
    viewSelector(vm){
        return ViewGenerator.GetNodeByTemplate(vm,this.template);
    }
    openTextConverter(b){
        if(b)
            return '-';
        return '+';
    }
    toggle(){
        this.isOpen = !this.isOpen;
    }
}
